import React, { useState, useEffect } from 'react';

// MUI Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import TextField from '@mui/material/TextField';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import Link from '@mui/material/Link';
import Divider from '@mui/material/Divider';

// Styled comp:
import { styled } from '@mui/material/styles';

// Theme
import { useTheme } from '@mui/material/styles';

// translation:
import { useTranslation } from 'react-i18next';

// context
import {useAuthData,useAuthDispatch} from '../../Context/AuthContext';

// model
import {signup,signin,logout,forgotPassword, login} from '../../models/userModel';



/******************************************************
 * Component Style
******************************************************/

    const FormLbl = styled(FormLabel) ({

    });


    const FormLink =  styled(Link) ({
        // width: '90%',
        alignSelf:'end',
        fontSize:12,
        color:"inherit",
        marginLeft:'1rem'
        
    })

    const FormCntrl = styled(FormControl) ({
        width: '90%',
        marginBottom:'0.5rem',
        [`&${FormLbl}`]: ({})
    });

    const FormButton = styled(Button) ({
         width: '90%',
         marginTop: '1.5rem',
         marginBottom:'1rem'
    });

    const SignUpTxt =  styled(Typography) ({
        textAlign: 'center'
    });

    const ObjectDetailContainer =  styled(Box) ({
            // width:'auto',
            // height:'auto',
            // textAlign:'center',
            display:'flex',
            flexDirection:'column',
            alignItems:'center',
            color:'gray',
            padding:'1rem',
            width:'20rem',
            [`&${FormCntrl}`]  : ({}),
            [`&${FormButton}`] : ({}),
            [`&${SignUpTxt}`] : ({}),
            [`&${FormLink}`]:({})

    });

    const OthOptBtn =  styled(Button) ({
        width: '90%',
        marginTop: '1.5rem',
        marginBottom:'1rem',
        marginRight:'1rem'
    })

    const OtherOptionsContainer =  styled(Box) ({
            display:'flex',
            flexDirection:'column',
            alignItems:'center',
            padding:'1rem',
            width:'20rem',
            [`&${OthOptBtn}`] : ({})

    })

/******************************************************
 * Component Definiton
******************************************************/
function UserLoginView() {

  const { t, i18n }  = useTranslation(),
        theme        = useTheme();


  const authData     = useAuthData();
  const authDispatch = useAuthDispatch();

  
  const [currView,setCurrView] = useState(!authData.isAuthenticated ? 'login' : 'logout' ); // params: login, signup, frgtpw,logout

  const [oEntry, setEntry] = useState({});

    let handleSubmit,
        handleChange,
        validateInputs,
        onSwitchView,
        _login,
        _signUp,
        _logout,
        _forgotPassword;




    onSwitchView = (oEvent,sParam) => {

      let nEntry = {...oEntry, password: "", confirmPassword:""}
      setEntry(nEntry);
        setCurrView(sParam);
    };


    handleChange = (oEvent) => {

      let sValue = oEvent.target.value,
          fname  = oEvent.target.name,
          nEntry;

      nEntry = {...oEntry, [fname]:oEvent.target.value}

      setEntry(nEntry);

      console.log(nEntry);

    }
    handleSubmit = async (oEvent) => {

      let dataEntry = {};

        try{

        oEvent.preventDefault();

        switch(currView) {

          case 'login':
            dataEntry = {
              email   : oEntry.email,
              password: oEntry.password
            }
            _login(oEvent,dataEntry);
          break;

          case 'signup':
            dataEntry = {
              fullname : oEntry.fullname,
              email    : oEntry.email,
              password : oEntry.password
            }

            _signUp(oEvent,dataEntry);

          break;


          case 'logout':
            _logout(oEvent, null);
          break;

          case 'frgtpw':
            dataEntry = {
              email    : oEntry.email
            }
            _forgotPassword(oEvent,dataEntry);
          break;


          default: //

        }

        } catch(e) {

        }

    }

    _signUp = async (oEvent,dataEntry) => {

      try {

        let response = await signup(dataEntry);

        authDispatch({type: 'signup', oUserData: null});

        onSwitchView(oEvent,'login')
        // setCurrView('login'); // ask user to login

        alert(response.msg);

      } catch(e) {
        console.log(e);
        alert('technical error. couldnt signup');
      }


      
    }

    _login =  async (oEvent,dataEntry) => {

        try {
          let response = await login(dataEntry);

          if (response.status === 200) {
            authDispatch({type: 'login', oUserData: response['user']});

            onSwitchView(oEvent,'logout')

            // setCurrView('logout');
            
          } else {
            alert(response.msg);
          }

        } catch(e) {
          alert('Failed to login. contact admin')
        } 
    };

    _logout =  async (oEvent, dataEntry) => {
        try {
          
          let response = logout(dataEntry);

            authDispatch({type: 'logout', oUserData: null}); 
            console.log(response);

            setCurrView('login');

      } catch(e) {
        alert('error couldnt logout');
      }
    }

    _forgotPassword = (oEvent,dataEntry) => {
      
    }



    return(

    <Card variant='outlined'>

        <ObjectDetailContainer 
            component={'form'}
            onSubmit={handleSubmit}
            noValidate>

        <Typography>{ authData.isAuthenticated ? authData.userData.fullname : 'no login' }</Typography>

        {/* FULL-NAME */}
        <FormCntrl sx={{ display: currView === 'signup' && currView !== 'logout' ? 'block' : 'none' }}>
          <FormLbl htmlFor="fullname">Full Name</FormLbl>
          <TextField
            value={oEntry.fullname}
            onChange={handleChange}
            error={true}
            // helperText='{emailErrorMessage}'
            size='small'
            id="fullname"
            type="text"
            name="fullname"
            // autoFocus
            required
            fullWidth
            variant="outlined"
            // color='error'
            // color={emailError ? 'error' : 'primary'}
          />
        </FormCntrl>

        {/* EMAIL */}
        <FormCntrl sx={{ display: currView !== 'logout' ? 'block' : 'none' }}>
          <FormLbl htmlFor="email">Email</FormLbl>
          <TextField
            value={oEntry.email}
            onChange={handleChange}
            // error={emailError}
            // helperText={emailErrorMessage}
            size='small'
            id="email"
            type="email"
            name="email"
            placeholder="your@email.com"
            autoComplete="email"
            // autoFocus
            required
            fullWidth
            variant="outlined"

            // color={emailError ? 'error' : 'primary'}
          />
        </FormCntrl>

        {/* PASSWORD */}
        <FormCntrl sx={{ display: currView === 'frgtpw' || currView === 'logout' ? 'none' : 'block' }}>
          <FormLbl htmlFor="password">Password</FormLbl>
          <TextField
            value={oEntry.password}
            onChange={handleChange}
            // error={passwordError}
            // helperText={passwordErrorMessage}
            size='small'
            name="password"
            placeholder="••••••"
            type="password"
            id="password"
            autoComplete="current-password"
            required
            fullWidth
            variant="outlined"/>
            {/*  color={passwordError ? 'error' : 'primary'} */}
          
        </FormCntrl>


        <FormLink
            onClick={ (oEvent) => onSwitchView(oEvent, 'frgtpw') }
            sx={{ display: currView === 'login' ? 'block' : 'none' }}> 
            {'Forgot Password'}
        </FormLink>

        {/* CONFIRM PASSWORD */}
        <FormCntrl sx={{ display: currView === 'signup' ? 'block' : 'none' }}>
          <FormLbl htmlFor="confirmPassword">confirm Password</FormLbl>
          <TextField
            value={oEntry.confirmPassword}
            onChange={handleChange}
            // error={passwordError}
            // helperText={passwordErrorMessage}
            size='small'
            name="confirmPassword"
            placeholder="••••••"
            type="password"
            id="confirmPassword"
            autoFocus
            required
            fullWidth
            variant="outlined"
            // color={passwordError ? 'error' : 'primary'}
          />
        </FormCntrl>

        <FormButton type="submit" variant="contained" color={currView === 'logout' ? 'error' : 'primary'} onClick={validateInputs}>
          {currView === 'login' ? 'Log-In' : ( currView === 'signup' ? 'SignUp' : ( currView === 'logout' ? 'logout' : 'Reset' ) )}
        </FormButton> 

       {/* <FormButton variant="contained" color='error' onClick={handleSubmit}>
          Sign-Out
        </FormButton>  */}

        {/* go to sign up  - REQUIRED WHEN SIGNUP IS OFFERED FOR USERS*/}
        {/* <SignUpTxt sx={{ display: currView === 'login' ? 'block' : 'none' }}>
            dont have an account ?
            <Link
              onClick={ (oEvent) => onSwitchView(oEvent, 'signup') }
              variant="body2"
              sx={{ alignSelf: 'center' }}>
              Sign up
            </Link>
        </SignUpTxt> */}

        <SignUpTxt sx={{ display: currView === 'signup' || currView === 'frgtpw' ? 'block' : 'none' }}>
            <Link
              onClick={(oEvent) => onSwitchView(oEvent, 'login') }
              variant="body2"
              sx={{ alignSelf: 'center' }}>
              back to login
            </Link>
        </SignUpTxt>

        </ObjectDetailContainer>

        <Divider disableGutters sx={{ display: currView !== 'logout' ? 'block' : 'none' }}>continue with</Divider>

        <OtherOptionsContainer component={'form'} sx={{ display: currView === 'login' || currView === 'signup' ? 'block' : 'none' }}>
            <OthOptBtn variant='outlined'>Google Account</OthOptBtn>
        </OtherOptionsContainer>
        
    </Card>
    );
}

export default UserLoginView;